import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NpsHelpComponent } from './nps-help.component';
import {ModalModule} from "ngx-bootstrap/modal";
import {NpsHelpModalModule} from "../nps-help-modal/nps-help-modal.module";
import { ButtonModule } from '@xref/xref-lib';



@NgModule({
  declarations: [NpsHelpComponent],
  imports: [
    CommonModule,
    ModalModule,
    NpsHelpModalModule,
     ButtonModule
  ],
  exports: [NpsHelpComponent]
})
export class NpsHelpModule { }
